import {
    SAVE_ID_PROOF,
    SAVE_ID_PROOF_FRONT_SIDE,
    SAVE_ID_PROOF_BACK_SIDE,
    RESET_ID_PROOF,
} from './actions';

export const initialState = {
    idProof: '',
    idProofFrontSide: '',
    idProofBackSide: ''
};

const idProofReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_ID_PROOF:
            return {
                ...state,
                idProof: action.idProof
            }
        case SAVE_ID_PROOF_FRONT_SIDE:
            return {
                ...state,
                idProofFrontSide: action.idProofFrontSide
            }
        case SAVE_ID_PROOF_BACK_SIDE:
            return {
                ...state,
                idProofBackSide: action.idProofBackSide
            }
        case RESET_ID_PROOF:
            return {
                ...state,
                ...initialState
            }
        default: return state
    }
}

export default idProofReducer;